<template>
  <div class="sidebar-outer-wrapper">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SidebarOuterWrapper',
});
</script>
<style lang="scss" scoped>
.sidebar-outer-wrapper {
  display: flex;
  flex-direction: column;
  padding: var(--spacing-100) var(--spacing-50);
  overflow-y: auto;
}
</style>
